import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d994194"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "addProjectModal",
  tabindex: "-1",
  "data-bs-backdrop": "true",
  "aria-labelledby": "addProjectModal",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header p-0" }
const _hoisted_5 = { class: "modal-title" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "An error has occurred", -1))
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading_spinner = _resolveComponent("loading-spinner")!
  const _component_creation_wizard = _resolveComponent("creation-wizard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.step == 1 ? 'Add Project & Process' : '') + _toDisplayString(_ctx.step == 2 ? 'Populate Variables' : '') + _toDisplayString(_ctx.step == 3 ? 'Match People' : ''), 1),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "data-bs-dismiss": "modal",
            "aria-label": "Close",
            ref: "closeBtn",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args)))
          }, null, 512)
        ]),
        (_ctx.submitted && !_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_loading_spinner, {
                text: `Creating: ${_ctx.percentage.toFixed()}%`
              }, null, 8, ["text"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _hoisted_8,
              (!_ctx.error.response)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.error), 1))
                : _createCommentVNode("", true),
              (_ctx.error.response && _ctx.error.response.data && _ctx.error.response.data.e
            )
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.error.response.data.e), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _withDirectives(_createVNode(_component_creation_wizard, {
          onSubmit: _ctx.submit,
          resetTrigger: _ctx.resetTrigger,
          "onUpdate:step": _cache[1] || (_cache[1] = ($event: any) => (_ctx.step = $event))
        }, null, 8, ["onSubmit", "resetTrigger"]), [
          [_vShow, !_ctx.submitted]
        ])
      ])
    ])
  ]))
}